"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadTable = void 0;

var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _baseTable = require("./baseTable");

var _utils = require("./utils");

var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor, _descriptor2, _descriptor3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var HeadTable = (_dec = (0, _vuePropertyDecorator.Component)({
  components: {
    BaseTable: _baseTable.BaseTable
  },
  directives: {
    ref: function ref(el, _ref) {
      var value = _ref.value;
      value === null || value === void 0 ? void 0 : value(el);
    }
  }
}), _dec2 = (0, _vuePropertyDecorator.Inject)(), _dec3 = (0, _vuePropertyDecorator.Prop)(), _dec4 = (0, _vuePropertyDecorator.Prop)(), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(HeadTable, _Vue);

  var _super = _createSuper(HeadTable);

  function HeadTable() {
    var _this;

    (0, _classCallCheck2.default)(this, HeadTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "table", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "fixed", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "scroll", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(HeadTable, [{
    key: "render",
    value: function render() {
      var h = arguments[0];
      var scroll = this.scroll,
          fixed = this.fixed,
          table = this.table;

      if (!scroll.y) {
        return null;
      }

      var style = {};
      var scrollbarWidth = (0, _utils.measureScrollbar)({
        direction: 'vertical'
      });
      var scrollbarWidthOfHeader = (0, _utils.measureScrollbar)({
        direction: 'horizontal'
      });

      if (scrollbarWidthOfHeader > 0 && !fixed) {
        style.marginBottom = "-".concat(scrollbarWidthOfHeader, "px");
        style.paddingBottom = '0px';
        style.minWidth = "".concat(scrollbarWidth, "px");
        style.overflowX = 'scroll';
        style.overflowY = scrollbarWidth === 0 ? 'hidden' : 'scroll';
      }

      return h("div", (0, _babelHelperVueJsxMergeProps.default)([{
        "class": {
          'ant-table-header': true,
          'ant-table-hide-scrollbar': scrollbarWidth > 0
        }
      }, {
        directives: [{
          name: 'ref',
          value: fixed ? function () {} : table.saveRefNode('headTable')
        }]
      }, {
        "on": {
          "scroll": table.handleBodyScroll
        }
      }]), [h("base-table", {
        "attrs": {
          "hasHead": true,
          "hasBody": false,
          "fixed": fixed,
          "scroll": scroll
        },
        "style": style
      })]);
    }
  }]);
  return HeadTable;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "table", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "fixed", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "scroll", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.HeadTable = HeadTable;